import { SiteRFPPhaseAPIResponse } from '@black-bear-energy/black-bear-energy-common'

export function getSiteRFPPhaseDisplayName(
  phase: SiteRFPPhaseAPIResponse
): string {
  switch (phase) {
    case SiteRFPPhaseAPIResponse.RFP:
      return 'RFP'
    case SiteRFPPhaseAPIResponse.Contracts:
      return 'Contracting'
    case SiteRFPPhaseAPIResponse.Derisking:
      return 'Development Derisking'
    case SiteRFPPhaseAPIResponse.Permits:
      return 'Permitting'
    case SiteRFPPhaseAPIResponse.NTP:
      return 'NTP'
    case SiteRFPPhaseAPIResponse.PreCon:
      return 'Pre-Construction'
    case SiteRFPPhaseAPIResponse.Construction:
      return 'Construction'
    case SiteRFPPhaseAPIResponse.Complete:
      return 'Complete'
    default:
      throw new Error(`No display name supported for phase ${phase}`)
  }
}
